/**
 * components/bottom-nav.tsx
 *
 * Shared bottom navigation bar — 5 tabs:
 * Home · Notes · Wishlist · Milestones · Countdowns
 *
 * Used across all main app pages
 */
import { useLocation, useNavigate } from 'react-router-dom'

const NAV_ITEMS = [
  { label: 'Home', icon: '🏠', path: '/home' },
  { label: 'Notes', icon: '✉️', path: '/notes' },
  { label: 'Wishlist', icon: '🌟', path: '/wishlist' },
  { label: 'Milestones', icon: '📍', path: '/milestones' },
  { label: 'Countdowns', icon: '⏳', path: '/countdowns' },
] as const

export default function BottomNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#F4C0D1] flex items-center justify-around min-h-[64px] pb-[env(safe-area-inset-bottom)] z-50 max-w-[430px] mx-auto overflow-hidden">
      {NAV_ITEMS.map((item) => {
        // Active if exact match, or if on a sub-route (e.g. /wishlist/wander)
        const active = pathname === item.path || pathname.startsWith(`${item.path}/`)
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center justify-center gap-[3px] flex-1 h-full transition-all duration-150 active:scale-[0.90] select-none touch-manipulation"
          >
            <span className="text-[20px] leading-none">{item.icon}</span>
            <span
              className={`font-['DM_Sans'] text-[10px] ${
                active ? 'font-medium text-[#D4537E]' : 'font-normal text-[#B89AA2]'
              }`}
            >
              {item.label}
            </span>
            {active && <div className="w-[4px] h-[4px] rounded-full bg-[#D4537E] mt-[1px]" />}
          </button>
        )
      })}
    </nav>
  )
}
